export default __webpack_public_path__ + "static/media/Travel-guru.cbe1423f.png";